export const SUBSTEP_ROUTES = {
  HAS_REFERRAL: {
    path: 'has-referral',
  },
  CONFIRM_NO_REFERRAL: {
    path: 'confirm-no-referral',
  },
};
